/**
 * verisoul.ts
 *
 * Injects the Verisoul SDK <script> tag at runtime using the runtime-config
 * values (VITE_VERISOUL_ENV / VITE_VERISOUL_PROJECT_ID) instead of relying on
 * Vite's build-time %VAR% substitution in index.html. This keeps Verisoul
 * consistent with the rest of the app's single-build-artifact, runtime-config
 * driven environment handling (see runtimeConfig.ts).
 *
 * The queueing proxy shim in index.html (which patches `window.Verisoul` so
 * that calls made before the real bundle loads are queued and replayed) is
 * unaffected by this change and still runs synchronously at parse time.
 */
import { getRuntimeEnv } from '@/constants/runtimeConfig'

export const loadVerisoulScript = (): void => {
  const env = getRuntimeEnv('VITE_VERISOUL_ENV', import.meta.env.VITE_VERISOUL_ENV)
  const projectId = getRuntimeEnv('VITE_VERISOUL_PROJECT_ID', import.meta.env.VITE_VERISOUL_PROJECT_ID)

  if (!env || !projectId) return

  const script = document.createElement('script')
  script.async = true
  script.src = `https://js.verisoul.ai/${env}/bundle.js`
  script.setAttribute('verisoul-project-id', projectId)
  document.head.appendChild(script)
}
